<template>
    <div class="search mt-4">
        <h1 class="pt-4 mb-0">Search for products</h1>

        <b-container fluid>
            <div class="card">
                <div class="card-block">
                    <div v-if="!activeQuery">
                        <h4 class="card-title">New Search</h4>

                        <h5 class="mt-4 mb-2">Create your search</h5>
                        <p class="text-center">Please note that text searches are case-sensitive.</p>

                        <ul class="list-unstyled p-4">
                            <li v-for="(q, index) in query" class="mb-1">
                                <b-row>
                                    <!--<b-col>
                                        <b-form-select v-model="q.operator" :options="['AND', 'OR']" v-if="index > 0"></b-form-select>
                                    </b-col>-->

                                    <b-col cols="4">
                                        <b-form-select v-model="q.field" :options="[{value:'name',text:'Name'},{value:'code',text:'Product Code'},{value:'costPrice',text:'Cost Price'},{value:'ssp',text:'SSP'},{value:'variation',text:'Variation'},{value:'colour/label',text:'Colour'},{value:'roof/prefix',text:'Roof Prefix'}]"></b-form-select>
                                    </b-col>

                                    <b-col cols="4">
                                        <b-form-select v-model="q.logic" :options="['is', 'starts with']"></b-form-select>
                                    </b-col>

                                    <b-col cols="4">
                                        <b-form-input v-model="q.value" placeholder="Enter a value here"></b-form-input>
                                    </b-col>

                                    <!--<b-col>
                                        <b-button v-on:click="removeQuery(index)">
                                            <icon name="minus"></icon>
                                        </b-button>

                                        <b-button v-on:click="addQuery">
                                            <icon name="plus"></icon>
                                        </b-button>
                                    </b-col>-->
                                </b-row>
                            </li>
                        </ul>

                        <div class="text-center">
                            <label>
                                <input type="checkbox" v-model="onlyPublished"> Only show me published products
                            </label>

                            <hr />

                            <div v-show="!loading">
                                <b-button variant="primary" size="lg" v-on:click="run" class="d-block ml-auto mr-auto mb-2">Run search</b-button>
                                or
                                <a v-on:click="all" class="d-block mt-2 mb-4 btn">show all products</a>
                            </div>

                            <div v-show="loading" class="mb-4">
                                <pulse-loader :loading="loading" color="#01a94e"></pulse-loader>
                            </div>
                        </div>
                    </div>

                    <div v-if="activeQuery">
                        <div class="p-4">
                            <product-list :results="result" :fb="fb"></product-list>
                        </div>

                        <p>Page {{ this.pageNumber }}</p>

                        <b-row>
                            <b-col cols="4">
                                <b-button v-if="activeQuery" v-on:click="prev()" class="d-block ml-auto mr-auto mb-4">Prev {{ this.resultsPerPage }}</b-button>
                            </b-col>

                            <b-col cols="4">
                                <strong>Page {{ this.pageNumber }}</strong>
                            </b-col>

                            <b-col cols="4">
                                <b-button v-if="activeQuery" v-on:click="next()" class="d-block ml-auto mr-auto mb-4">Next {{ this.resultsPerPage }}</b-button>
                            </b-col>
                        </b-row>

                        <b-button v-on:click="activeQuery = null" class="d-block ml-auto mr-auto mb-4">Reset</b-button>
                    </div>
                </div>
            </div>
        </b-container>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import { mapState } from 'vuex'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner'
import ProductList from './ProductList.vue'

export default {
  name: 'productSearch',
  props: ['fb'],
  components: {
    ProductList,
    Simplert,
    PulseLoader
  },
  computed: {
    ...mapState(['user'])
  },
  data () {
    return {
      query: [
        {
          operator: '',
          field: 'name',
          logic: 'starts with',
          value: ''
        }
      ],
      onlyPublished: false,
      activeQuery: null,
      result: null,
      loading: false,
      resultsPerPage: 250,
      pageNumber: 1
    }
  },
  methods: {
    addQuery () {
      this.query.push({
        operator: 'OR',
        field: '',
        logic: '',
        value: ''
      })
    },
    removeQuery (index) {
      this.query.splice(index, 1)
    },
    getQuery (isPaginating) {
      let ref = this.fb.database().ref('products')
      let qry = this.query[0]

      if (qry.field === 'c111ode') {
        console.log('ordering by key')
        ref = ref.orderByKey()
      } else {
        console.log('ordering by child', qry.field)
        ref = ref.orderByChild(qry.field)
      }

      if (!isPaginating) {
        console.log('starting at', qry.value)
        ref = ref.startAt(qry.value)
        // figure out where to end at
        if (qry.logic === 'is') {
          console.log('ending at', qry.value)
          ref = ref.endAt(qry.value)
        } else if (qry.logic === 'starts with') {
          console.log('ending at', qry.value + '(utf8 end)')
          ref = ref.endAt(qry.value + '\uf8ff')
        }
      }
      console.log('getQuery, ref = ', ref)
      return ref
    },
    run () {
      this.loading = true
      this.getQuery().limitToFirst(this.resultsPerPage).on('value', this.displaySnapshot)
    },
    displaySnapshot (snapshot) {
      if (snapshot && snapshot.val()) {
        console.log('snapshot = ', snapshot)
        let val = snapshot.val()
        console.log('val = ', val)
        this.result = Object.values(snapshot.val())
        if (typeof val === 'object') {
          for (let ky in val) {
            if (val.hasOwnProperty(ky)) {
              try {
                val[ky]['.key'] = ky
              } catch (e) {
                console.err('exception caught: ', e, ' val = ', val)
              }
            }
          }
        } else {
          console.log('val isn\'t an object, it is ', val)
        }
        this.result = Object.values(val)
        console.log('result = ', this.result)
        this.loading = false
        this.activeQuery = true
      } else {
        this.loading = false
        this.activeQuery = false
        this.$refs.simplert.openSimplert({
          title: 'None found',
          type: 'info',
          message: 'No results found'
        })
      }
    },
    next () {
      console.log('getting next')
      this.loading = true
      let last = this.result[this.result.length - 1]
      this.getQuery(true).startAt(last[this.query[0].field]).limitToFirst(this.resultsPerPage).on('value', (snapshot) => {
        this.displaySnapshot(snapshot)
        this.pageNumber++
      })
    },
    prev () {
      console.log('getting prev')
      this.loading = true
      if (this.result.length) {
        let last = this.result[0]
        this.getQuery(true).endAt(last[this.query[0].field]).limitToLast(this.resultsPerPage).on('value', (snapshot) => {
          this.displaySnapshot(snapshot)
          this.pageNumber--
        })
      }
    },
    all () {
      console.log('getting all')
      this.loading = true
      this.query = [
        {
          operator: 'OR',
          field: 'code',
          logic: '',
          value: ''
        }
      ]
      this.getQuery().limitToFirst(this.resultsPerPage).on('value', this.displaySnapshot)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductSearch.vue